import React from 'react'
import Group from 'components/utils/Group'
import Modal from 'LuxKit/Modal/Modal'
import CabinCategoriesModalContent from './CruiseCabinCategoriesModal'

interface Props {
  modalCategories: Array<App.CruiseShipCabinCategory>
  cabinType: string
}

function CabinDetailsModal({ cabinType, modalCategories }: Props) {
  return <Modal
    title={`${cabinType} cabins`}
    size="L"
  >
    <Group direction="vertical" gap={24}>
      {modalCategories.map((cabinCategory) => (
        <CabinCategoriesModalContent key={cabinCategory.id} cabinCategory={cabinCategory} />
      ))}
    </Group>
  </Modal>
}

export default CabinDetailsModal
